module.exports = __webpack_public_path__ + "img/20.9c79d68d.jpg";